import type { google as GoogleMapsApi } from "@jti/fe-clients";

export function initAutocomplete(
  _google: GoogleMapsApi,
  input: HTMLInputElement,
  isoCountyCode: string,
  onPlace?: (result: google.maps.places.PlaceResult) => void
) {
  const autocomplete = new _google.maps.places.Autocomplete(input, {
    types: ["address"],
  });
  autocomplete.setFields(["address_component"]);
  autocomplete.setComponentRestrictions({
    country: [isoCountyCode],
  });
  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();
    onPlace?.(place);
  });
}
